module.exports = __webpack_public_path__ + "static/media/musgrave.fbf92f46.jpg";